import React from 'react';
import { LaurelLeft } from './svgs/LaurelLeft';
import { LaurelRight } from './svgs/LaurelRight';

const CustomDesingItem = ({ title, label, value }) => {
  return (
    <div className='flex flex-col items-center'>
      <h4 className='notosans-italic max-sm:text-xl max-md:text-2xl max-lg:text-3xl text-6xl text-white'>{title}</h4>
      <span className='notosans-semibold max-sm:text-lg max-md:text-xl max-lg:text-2xl text-5xl font-bold -mt-6'>
        {value}
        <span className='text-brand-red'>+</span>
      </span>
      <span className='notosans-semibold text-xs max-sm:text-[6px] max-md:text-[8px]'>{label}</span>
    </div>
  )
}

export const CustomDesignSection = ({ config }) => {
  return (
    <div className="relative py-4 md:py-7 lg:py-8">
      <div className="relative z-10 max-w-7xl mx-auto sm:px-6 lg:px-8">
        <div className="flex flex-row justify-center gap-4 md:gap-6 lg:gap-8">
          <LaurelLeft className="w-[90px] max-sm:w-[20px] max-md:w-[40px] max-lg:w-[60px]"/>
          <div className='flex w-full justify-between items-center'>
            <CustomDesingItem title="Clients" label="Satisfied Customers" value={config.clients} />
            <CustomDesingItem title="Years" label="Years of Experience" value={config.years} />
            <CustomDesingItem title="Projects" label="Creatives" value={config.projects} />
            <CustomDesingItem title="Awards" label="Winning Awards" value={config.awards} />
          </div>
          <LaurelRight className="w-[90px] max-sm:w-[20px] max-md:w-[40px] max-lg:w-[60px]"/>
        </div>
      </div>
    </div>
  );
};
